import { apis } from "apis";
import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";
import { ServiceInjectable } from "src/utils/services";
import { IPackageModel } from "@/model";

/**
 *  套餐服务
 * @class
 * @version 1.0.0
 */
@ServiceInjectable()
export default class PackageService extends ServiceBase {

    /**
     * 获取预约套餐列表
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async getPackagePage(data: any): Promise<IHttpResponse> {
        let response = await this.apis.getPackagePage({ data });
        return response;
    }

    /**
     * 删除预约套餐
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async delPackage(id: any): Promise<IHttpResponse> {
        let response = await this.apis.delPackage({ urlPath:{id} });
        return response;
    }

    /**
     * 获取预约套餐详情
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async getPackage(id: any): Promise<IHttpResponse> {
        let response = await this.apis.getPackage({ urlPath:{id} });
        return response;
    }

    /**
     * 新增/编辑机构
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async opertionPackage(data: IPackageModel): Promise<IHttpResponse> {
        let response;

        if(data.id)
        {
            response = await this.apis.editPackage({ data: data });
        }
        else
        {
            response = await this.apis.addPackage({ data: data });
        }
        
        return response;
    }

    /**
     * 获取套餐机构
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getPackageHospRel(packageId: number): Promise<IHttpResponse> {
        let  response = await this.apis.getPackageHospRel({ params: {packageId} });
        
        return response;
    }

    /**
     * 修改套餐项目
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async updatePackageItem(data: any): Promise<IHttpResponse> {
        let  response = await this.apis.updatePackageItem({ data });
        
        return response;
    }

    /**
     * 获取套餐项目
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getPackageItems(packageId: number): Promise<IHttpResponse> {
        let  response = await this.apis.getPackageItems({ params: {packageId} });
        
        return response;
    }

    /**
     * 编辑套餐关联机构
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async operationPackageHospRel(data: any): Promise<IHttpResponse> {
        let  response = await this.apis.operationPackageHospRel({data: data});
        
        return response;
    }

}